import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainPart2ID() {
  const articleData = {
    title: 'Mengapa Beberapa Orang Membuat Kita Merasa Terkuras? Bagian 2',
    description: 'Pola yang lebih halus yang menguras energi Anda. AI mendeteksi penjelasan berlebihan, sok tahu, kebingungan emoji & lainnya.',
    slug: 'emotional-drain-part-2',
    publishDate: '2025-11-16',
    author: 'Editorial Toxic Detector'
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Tautan disalin ke papan klip!');
    }
  };
  return <>
      <MetaTags title="Mengapa Beberapa Orang Membuat Kita Merasa Terkuras? Bagian 2 | ToxicDetector" description="Pola yang lebih halus yang menguras energi Anda. AI mendeteksi penjelasan berlebihan, sok tahu, kebingungan emoji & lainnya." keywords="pengurasan emosi, vampir energi, hubungan beracun, analisis AI" canonical={`https://toxicdetector.com/id/blog/${articleData.slug}`} ogType="article" ogImage="https://toxicdetector.com/images/logo.png" schema={[articleSchema]} data-id="element-6859" data-mp="3mqpxk0a2ksyh" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-6860" data-mp="1xaqhs0by459v">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-6861" data-mp="1yt8gtjpd6rid">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-6862" data-mp="23rs5hrvcehef">
            <div className="flex items-center justify-between" data-id="element-6863" data-mp="23ra7app4dt3v">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-6864" data-mp="1otrbj3e0yfmx">
                <span className="text-2xl" data-id="element-6865" data-mp="1ttm3795mj991">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-6866" data-mp="1tsb0zdrtu9k1">
                  ToxicDetector
                </span>
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-6867" data-mp="1ktz978f855q0">
                <Share2 size={20} className="text-gray-600" data-id="element-6868" data-mp="1b34nc55w4853" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-6869" data-mp="x4o6vmi8739r">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-6870" data-mp="114yltonzx40r">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-6871" data-mp="ij0l5wwdjqos" />
            Kembali ke Beranda
          </Link>

          <header className="mb-16" data-id="element-6872" data-mp="riw26icm2fwq">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-6873" data-mp="mirikjgep52a">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-6874" data-mp="11dxqjbz2bdy9">
              <time dateTime={articleData.publishDate} data-id="element-6875" data-mp="wfw6oottbalq">
                {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-6876" data-mp="1k5grzedfujy6">•</span>
              <span data-id="element-6877" data-mp="1k45prizn5k96">{articleData.author}</span>
            </div>
          </header>

          <div className="prose prose-lg max-w-none" data-id="element-6878" data-mp="1f903gj2bu3kk">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-6879" data-mp="1z9tbu6zm7shj">
              Selamat datang kembali di Bagian 2 dari seri kami tentang
              pengurasan emosi. Di Bagian 1, kami membahas vampir energi yang
              jelas. Sekarang kita menyelam lebih dalam ke pola yang lebih
              halus.
            </p>

            <section className="mb-16" data-id="element-6880" data-mp="2czwoc68p07ts">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6881" data-mp="1gap6p9b72iv5">
                1️⃣ Penjelas Berlebihan
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6882" data-mp="1kcj14zusqqmv">
                Seseorang yang menjawab pertanyaan sederhana dengan novel dan
                mengikat energi Anda dengan detail yang tidak perlu.
              </p>
            </section>

            <section className="mb-16" data-id="element-6883" data-mp="30qivzwesbq39">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6884" data-mp="30pr2cr4r02fm">
                2️⃣ Si Sok Tahu
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6885" data-mp="35r6oynmkqh04">
                Tidak peduli apa yang Anda katakan, orang ini tahu lebih baik
                atau pernah mengalaminya lebih buruk. Perilaku klasik
                "One-Upper".
              </p>
            </section>

            <section className="mb-16" data-id="element-6886" data-mp="ka47alpc4ikl">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6887" data-mp="fdnkpvxsac9m">
                3️⃣ Kebingungan Emoji
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6888" data-mp="bd3m0nxkb0ld">
                Menggunakan emoji pasif-agresif seperti 🙂 atau 🙃 dalam konteks
                serius untuk menciptakan kebingungan.
              </p>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl mt-16" data-id="element-6889" data-mp="3sk5plh8i04ll">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-6890" data-mp="1vrm2gwsuo9vi">
              Lindungi energi Anda.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-6891" data-mp="1qt2i30twn659">
              Jangan biarkan diri Anda terkuras. Cari tahu siapa yang baik untuk
              Anda.
            </p>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-6892" data-mp="3q1as5h4przzu">
              Pindai sekarang →
            </Link>
          </div>

          <div className="mt-20" data-id="element-6893" data-mp="7ri9426ed2qb">
            <RelatedBlogPosts posts={[{
            title: 'Mengapa Beberapa Orang Membuat Kita Merasa Terkuras?',
            description: 'Pelajari bagaimana AI Toxic Detector mendeteksi komunikasi sepihak.',
            slug: 'emotional-drain-relationships-ai',
            emoji: '😮‍💨'
          }, {
            title: '7 Tanda Gaslighting',
            description: 'Temukan 7 tanda gaslighting yang dideteksi AI kami secara instan.',
            slug: '7-signs-of-gaslighting',
            emoji: '💀'
          }]} data-id="element-6894" data-mp="ct7otv4ke4kq" />
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-6895" data-mp="2pyvv6u3yhbtc">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-6896" data-mp="2kzrqafo2e08t">
            <p className="text-gray-400 text-sm" data-id="element-6897" data-mp="2kygkybez0kfl">
              © {new Date().getFullYear()} ToxicDetector. Hak cipta dilindungi
              undang-undang.
            </p>
          </div>
        </footer>
      </div>
    </>;
}